<template>
    <div>
        <div class="w3-container w3-margin-bottom zero">
            <span class="w3-col w-50pc flow-blue-color zero">
                <!--<span class="font-weight-bold w3-col zero flow-margin-right w3-left-align w-auto">-->
                    <!--{{ $t("sortBy") }}-->
                <!--</span>-->
                <span class="w3-col w-60pc zero flow-margin-right" id="sort-select">
                    <flow-select :items="sortOptions"
                        :valueKey="'name'"
                        :valueKeyIndex="'id'"
                        :callback="setSortFunc">
                    </flow-select>
                </span>
                <span class="w3-col w-5pc zero flow-margin-left fa fa-stack cursor-pointer w3-ripple" @click="sortOrder = -sortOrder">
                    <i class="fa fa-stack-2x fa-circle flow-green3"></i>
                    <i class="fa fa-stack-1x w3-xlarge w3-animate-opacity w3-text-deep-orange" v-bind:class="sortOrder > 0 ? 'fa-sort-alpha-up' : 'fa-sort-alpha-down'"></i>
                </span>
            </span>

            <span class="table-count w3-col w-30pc w3-right w3-right-align flow-blue-color w3-medium w3-padding">{{$t("showing")}} <b>{{ sortedPatients.length }}</b> {{$t("patients")}}</span>
        </div>

        <div class="flow-card blue-top w3-padding">
            <table class="w3-table w3-bordered flow-table patients-table">
                <thead class="">
                <th>{{ $t("time") }}</th>
                <th>{{ $t("patient") }}</th>
                <th>{{ $t("appointment") }}</th>
                <th>{{ $t("tag") }}</th>
                <th>{{ $t("location") }}</th>
                <th v-show="!showMinimalView">Consults</th>
                </thead>
                <tbody v-show="patients.length === 0">
                <tr>
                    <td colspan="8" class="w3-center flow-blue-color">
                        <b class="font-size-1pt25em">{{$t("noPatients")}}</b>
                    </td>
                </tr>
                </tbody>
                <tbody v-show="patients.length !== 0">
                <tr v-for="patient in sortedPatients"
                    v-bind:class="patient.patientId === selectedPatientId ? 'active' : ''"
                    v-bind:id="patient.patientId"
                    v-if="patient" :key="patient.patientId">
                    <td>
                        {{ patient.appointmentTime }}
                    </td>

                    <td class="primary" @click="patientSelected(patient)">
                        <patient-status class="w3-show-inline-block w3-margin-right" :status="patient.status" :showMarker="true"></patient-status>
                        <span>
                            {{ showMinimalView ? trim(patient.patientName) : patient.patientName }}
                        </span>
                        <span v-if="loggedIn(patient)">
                            <i v-show="!showMinimalView" class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left" :title="$t('loggedIn')"></i>
                        </span>
                    </td>

                    <td>
                        <span v-if="patient.physician">
                            {{ patient.physician.name }} -
                        </span>
                        <span v-if="patient.consultationGroup" class="consultation-group">
                            <span v-show="showMinimalView">{{ patient.consultationGroup.shortName }}</span>
                            <span v-show="!showMinimalView">{{ patient.consultationGroup.displayName }}</span>
                        </span>
                        <span>&nbsp;</span>
                        <span v-if="patient.consultationRoom" class="consultation-room flow-btn w3-round-medium font-weight-bold">
                            <router-link :to="{ name: 'room', params: { roomId: patient.consultationRoom.id }}"
                                         :title="patient.consultationRoom.displayName">
                                {{ patient.consultationRoom.displayName }}
                            </router-link>
                        </span>
                    </td>

                    <td>
                        {{ patient.ticket }}
                    </td>


                    <td>
                        <span v-if="patient.latestPosition">{{ patient.latestPosition.displayName }}</span>
                        <span v-else></span>
                    </td>

                    <td v-show="!showMinimalView">
                        {{ patient.numOfCurrentAppointment + "/" + patient.numOfAppointments }}
                        <appointment-priority
                                v-if="!isStatusLeftConsultation(patient.status) && !isStatusInConsultation(patient.status) && !isStatusLeavingConsultation(patient.status)"
                                :appointmentId = "patient.appointmentId"
                                :patientId = "patient.patientId"
                                :appointmentHasPriority = "patient.hasPriority">
                        </appointment-priority>
                    </td>

                    <td>
                        <router-link
                                class="fa fa-external-link-alt flow-blue-color"
                                target="_blank"
                                :to="{ name: 'patient', params: { id: patient.patientId }}"
                                :title="$t('goToPatientDetail')">
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { EventBus } from "../../main";
    import PatientStatus from "../common/PatientStatus";
    import AppointmentPriority from "../patient/AppointmentPriority";
    import FlowSelect from "../common/FlowSelect";
    const frc = Vue.prototype.$frc;

    export default {
        name: "PatientList",
        components: {FlowSelect, PatientStatus, AppointmentPriority},
        props: ['patients', 'showMinimalView', 'callbackOnPatientSelect' , 'selectedPatientId', 'preSelectedPatientId'],
        data: function () {
            return {
                sortedPatients: [],
                activeSortCompare: this.priorityAndTimeSort,
                sortOrder: 1,
                sortOptions: [
                    {
                        id: 1,
                        name: this.$t("priorityAndTime"),
                        callback: this.activeSortCompare = this.priorityAndTimeSort
                    },
                    {
                        id: 2,
                        name: this.$t("name"),
                        callback: this.activeSortCompare = this.nameSort
                    },
                    {
                        id: 3,
                        name: this.$t("time"),
                        callback: this.activeSortCompare = this.timeSort
                    },
                    {
                        id: 4,
                        name: this.$t("status"),
                        callback: this.activeSortCompare = this.statusSort
                    }
                ],
                patientFound: false
            }
        },
        watch: {
            patients: function(newVal, oldVal) {
                this.sortedPatients = [];
                this.sortedPatients = newVal.concat().sort(this.activeSortCompare);
                if (this.sortOrder < 0) {
                    this.sortedPatients.reverse();
                }
            },
            activeSortCompare: function(newVal, oldVal) {
                this.sortPatients();
            },
            sortOrder: function(newVal, oldVal) {
                this.sortedPatients.reverse();
            }
        },
        mounted() {
            console.log("Mounting!");
            this.sortedPatients = this.patients;
            this.sortPatients();
            var app = this;
            EventBus.$on("patientUpdated", this.updatePatientEntry);
            EventBus.$on("priorityUpdated", this.updatePatientEntryOnPriority);
            EventBus.$on("appointmentDeleted", this.updatePatientEntry);
            EventBus.$on("appointmentAdded", this.updatePatientEntryOrAdd);
            EventBus.$on("Relocated", this.updatePatientEntry);

            if (!this.preSelectedPatientId) {
                return;
            }
            for (var i = 0; i < this.patients.length; i++) {
                if (this.patients[i].patientId === this.preSelectedPatientId) {
                    this.patientSelected(this.patients[i]);
                    break;
                }
            }
        },
        beforeDestroy() {
            EventBus.$off("patientUpdated", this.updatePatientEntry);
            EventBus.$off("priorityUpdated", this.updatePatientEntryOnPriority);
            EventBus.$off("appointmentDeleted", this.updatePatientEntry);
            EventBus.$off("appointmentAdded", this.updatePatientEntryOrAdd);
            EventBus.$off("Relocated", this.updatePatientEntry);
        },
        computed: {
            openPrimaryInNewTab() {
                return this.callbackOnPatientSelect !== undefined;
            }
        },
        methods: {
            loggedIn(patient) {
                var res = Vue.getValueForKey(patient.patientProperties.entry, 'device');
                return res;
            },
            setSortFunc(sortOption) {
                this.activeSortCompare = sortOption.callback;
            },
            priorityAndTimeSort(a, b) {
                if (a.hasPriority && !b.hasPriority) {
                    return -1;
                }

                if (b.hasPriority && !a.hasPriority) {
                    return 1;
                }

                return a.appointmentTime.localeCompare(b.appointmentTime);
            },
            timeSort(a, b) {
                return a.appointmentTime.localeCompare(b.appointmentTime);
            },
            nameSort(a, b) {
                return a.patientName.localeCompare(b.patientName);
            },
            statusSort(a, b) {
                return Vue.getStatusRank(a.status) - Vue.getStatusRank(b.status);
            },
            sortPatients() {
                this.sortedPatients.sort(this.comparator);
            },
            comparator(a, b) {
                return this.activeSortCompare(a, b) * this.sortOrder;
            },
            trim(name) {
                if (name && name.length > 15) {
                    return name.slice(0, 15) + "...";
                }

                return name;
            },
            patientSelected(patient) {
                this.passCallbackPatient(patient);
            },
            passCallbackPatient(patient){
                var device = this.loggedIn(patient) ? true : false;
                if (this.callbackOnPatientSelect) {
                    this.callbackOnPatientSelect({id: patient.patientId, name: patient.patientName, internalIds: patient.internalIds, status: patient.status, device: device});
                }
            },
            updatePatientEntryOnPriority(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id , patientId).then(function (res) {
                    app.setPatientEntry(patientId, res.data);
                    // Vue.scrollToElementWithId(patientId);
                });
            },
            updatePatientEntry(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id , patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Nothing fetched. Will remove this entry if exists.");
                        app.setPatientEntry(patientId, undefined);
                        return;
                    }
                    app.setPatientEntry(patientId, res.data);
                    app.passCallbackPatient(res.data);
                    Vue.scrollToElementWithId(patientId);
                });
            },
            updatePatientEntryOrAdd(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id , patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Nothing fetched. Will remove this entry if exists.");
                        app.setPatientEntry(patientId, undefined);
                        return;
                    }

                    app.setPatientEntry(patientId, res.data);

                    if (!app.patientFound) {
                        app.patients.push(res.data);
                    }

                    app.passCallbackPatient(res.data);
                    Vue.scrollToElementWithId(patientId);
                });
            },
            setPatientEntry(index, patient) {
                this.patientFound = false;
                for (var i = 0; i < this.patients.length; i++) {
                    if (this.patients[i] && this.patients[i].patientId === index) {
                        this.$set(this.patients, i, patient);
                        this.patientFound = true;
                        break;
                    }
                }
            }
        }
    }
</script>

<style>
</style>